import { createFileRoute } from '@tanstack/react-router'
import { AppearanceSection } from '../../../features/settings/appearance-section'

/** The user's own look for this browser: open to everyone signed in. */
export const Route = createFileRoute('/_app/settings/appearance')({
  staticData: { crumb: 'settingsSection' },
  component: AppearanceSection,
})
